import axios, { AxiosError } from "axios";
import { combinedUrls } from "../../../URL/functions";
import { projectUrls } from "../../../URL/ApplicationUrls";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";
import { MdmApiError } from "../../../Errors/MdmApiError";

export const useAddFtlRoute = async (
  projectId: number | undefined,
  routeName: string | undefined
) => {
  const url = combinedUrls(
    projectUrls.projectWithId(projectId).apiUrl,
    `/AddFtlRoute/${routeName}`
  );
  return axios
    .post(url)
    .catch((error: AxiosError<MdmApiError>) => apiErrorNotificationToast(error));
};
